import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { ProjectsModule } from './projects/projects.module';
import { AppRoutingModule } from './app-routing.module';
import { Auth } from './auth/auth.service';
import { LoginComponent } from './auth/login/login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClientRepository } from './client.service';
import { WidgetsModule } from './widgets/widgets.module';
import { ObjectService } from './shared/object.service';
import { BaseComponent } from './base/base.component';
import { BaseGuard } from './base/base.guard';
import { SharedModule } from './shared/shared/shared.module';
import { OptionService } from './shared/option.service';
import { ClientsModule } from './clients/clients.module';
import { UserService } from './shared/user.service';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AuthInterceptor } from "app/auth/auth.interceptor";
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UsersModule } from './users/users.module';
import { ClarityModule } from '@clr/angular';
import { SettingsModule } from './settings/settings.module';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    BaseComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    DashboardComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    HttpModule,
    AppRoutingModule,
    ProjectsModule,
    WidgetsModule,
    UsersModule,
    ClientsModule,
    SettingsModule,
    SharedModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    ClarityModule
  ],
  providers: [
    //HttpClientAuth,
    Title,
    Auth,
    BaseGuard,
    ClientRepository,
    ObjectService,
    OptionService,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts